import React, { FC, ReactNode } from 'react'
import styled from 'styled-components'

import { HeadingL, HeadingXXXXL } from 'uiComponents/atoms/Text/Headings'
import { mediaTabletAndDown } from 'uiComponents/constants/customMedia'

export const BrandTitle = styled(HeadingXXXXL)`
  margin-bottom: 20px;

  @media ${mediaTabletAndDown} {
    font-size: 46px;
  }
`

const SubTitle = styled(HeadingL)`
  margin-bottom: 5px;
`

const Wrapper = styled.div`
  padding-top: 60px;
  display: flex;
  flex-direction: column;
`

interface Props {
  dataTestId?: string
  className?: string
  title?: ReactNode
  subTitle: ReactNode
}

const RecoHeadlineGroup: FC<React.PropsWithChildren<Props>> = ({
  dataTestId,
  className,
  title,
  subTitle,
  children,
}) => {
  return (
    <Wrapper
      data-testid={dataTestId ?? 'RecoHeadlineGroup'}
      className={className}
    >
      <SubTitle data-testid="SubTitle">{subTitle}</SubTitle>
      {title}

      {children}
    </Wrapper>
  )
}

export default RecoHeadlineGroup
